import { render } from "./AdminProjects.vue?vue&type=template&id=c2714b70"
import script from "./AdminProjects.vue?vue&type=script&lang=js"
export * from "./AdminProjects.vue?vue&type=script&lang=js"

import "./AdminProjects.vue?vue&type=style&index=0&id=c2714b70&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__